import { CALL_API } from "../middleware";
import { GetNotificationsResponseBody } from "../types/api-types";
import { GET_NAVBAR_NOTIFICATIONS, GET_NAVBAR_NOTIFICATIONS_SUCCESS } from "../types/onBoarding";

export const getNotifications =
    ({ rmId, category, clientCode, limit=10, page=1, sort, order }: { rmId: string[], category: string[], clientCode: string[] | [] | any, limit: number, page: number, sort?: string, order?: string }) =>
        async (dispatch: any): Promise<GetNotificationsResponseBody> => {
            return await dispatch({
                [CALL_API]: {
                    url: '/onboarding/dashboard/getNotification',
                    method: 'POST',
                    types: [GET_NAVBAR_NOTIFICATIONS_SUCCESS, GET_NAVBAR_NOTIFICATIONS],
                    body: { rmId, category, clientCode, limit, page, sort, order },
                },
            });
        };